var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174.225,
    height: 411.177,
    viewBox: "0 0 174.225 411.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#6b8ba7;}.c{fill:#1a304c;}.d{clip-path:url(#a);}.e{clip-path:url(#b);}.f{opacity:0.13;}.f,.u,.x{isolation:isolate;}.g{clip-path:url(#c);}.h{fill:#040504;}.i{clip-path:url(#d);}.j{clip-path:url(#e);}.k{fill:#1a0f0d;}.l{fill:#e08e71;}.m{fill:#fff;}.n{fill:#ce7760;}.o{opacity:0.3;}.p{clip-path:url(#f);}.q{opacity:0.2;}.r{clip-path:url(#g);}.s{fill:#ba7061;}.t{fill:#2a120e;}.u{opacity:0.14;}.v{clip-path:url(#h);}.w{clip-path:url(#i);}.x{opacity:0.12;}.y{clip-path:url(#j);}.z{clip-path:url(#k);}.aa{clip-path:url(#l);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 160.842,
    height: 22.071
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 160.843,
    height: 22.071
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 160.842,
    height: 22.072
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 174.225,
    height: 405.564
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 174.225,
    height: 405.564
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 71.373,
    height: 138.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 53.127,
    height: 54.058
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.233,
    height: 8.994
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.492,
    height: 9.303
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.664,
    height: 10.604
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 29.84,
    height: 22.458
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.931,
    height: 12.316
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-842.585 -673.036)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(845.811 1062.142)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M0,10.915S32,0,81.721,0s79.121,12.742,79.121,12.742-31.691,9.439-78.887,9.329C24.115,21.934,0,10.915,0,10.915",
    transform: "translate(0 0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(842.585 673.036)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M43.735,4.967s5.439-5.842,11.5-3.575c8.777,3.275,45.9,20.5,36.685,60.293-9.711,41.918-39.868,31.2-39.868,31.2s-36.332,2.052-36.3-38.421S36.386,1.848,43.735,4.967",
    transform: "translate(12.91 0.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.334,48.759s1.638-3.457,5.195.637S77.665,84.513,77.665,84.513s3.015,21.128-7.584,8.978C61.013,83.1,47.334,48.759,47.334,48.759",
    transform: "translate(38.791 38.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M36.107,47.385c.466-.024.932-.049,1.39-.067l.537-.027V47.3c8.279-.313,15.737.315,20.664.353.7,3.932,3.865,7.1,7.476,9.462.546.777,1.092,1.55,1.67,2.34,4.885,6.716,7.749,11.141,4.607,19.662-3.093,8.384.267,15.793,3.406,23.55a197.332,197.332,0,0,0-39.351-1.325c.329-7.22-3.441-14.525-4.874-21.521-1.292-6.308-2.953-12.817-4.4-19.34a33.743,33.743,0,0,0,8.876-13.1",
    transform: "translate(22.316 38.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M36.473,95.111c.329-7.22-3.441-14.525-4.875-21.521-1.254-6.126-2.891-12.442-4.321-18.776H68.953c4.163,5.872,6.352,10.244,3.457,18.073-3.093,8.384.267,15.793,3.406,23.55a197.256,197.256,0,0,0-39.344-1.326",
    transform: "translate(22.354 44.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M73.768,104.667s12.722,37.451-2.489,87.956c0,0-6.756,58.82-.728,102.286.32,2.316-7.067.1-7.067.1S35.855,215.378,51.166,194.761L35.891,116.812Z",
    transform: "translate(29.413 85.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M68.41,112.38a439.559,439.559,0,0,1-17.933,93.984s2.287,10.371-18.45,89.393l-6.4-8.5s-6.614-71.5,6.527-86.445c0,0-12.282-75.241-6.21-94.086S68.41,112.38,68.41,112.38",
    transform: "translate(19.642 81.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.713,213.46c1.417-30.943-16.772-74.646-5.686-107.6,5.14-15.273,14.513-19.318,15.384-23.108a20.626,20.626,0,0,0,.275-5.217c2.429,0,4.838-.013,7.2.016,10.313.124,20.662.084,30.965-.442,2.4-.12,4.8-.289,7.2-.469l1.476,6.243c2.52,4.185,10.248,21.481,12.167,41.756,1.765,18.637-6.243,65.334-11.7,86.931,0,0-10.189,4.018-29.4,4.018a151.238,151.238,0,0,1-27.875-2.133",
    transform: "translate(16.741 62.812)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(37.168 139.455)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.026,105.864c5.14-15.273,14.513-19.318,15.384-23.108a20.626,20.626,0,0,0,.275-5.217c2.429,0,4.838-.013,7.2.016,10.313.124,20.662.084,30.965-.442,2.4-.12,4.8-.289,7.2-.469l1.476,6.243a78.467,78.467,0,0,1,5.277,11.9,102.965,102.965,0,0,0-13.961-.933c-15.128-.468-30.306,1.568-36.6,17.244-6.337,15.786-3.683,36.076-2.649,52.513,1.092,17.384,3.31,34.462-.238,51.056-5.588-.573-8.632-1.2-8.632-1.2,1.414-30.945-16.776-74.648-5.691-107.6",
    transform: "translate(-20.428 -76.644)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M61.033,204.711l15.522,31.232,7.968-.066L81.4,239.322H62.558L53.5,224.171l4.62,15.151H53.689l-9.407-23.539L51.1,198.008Z",
    transform: "translate(36.29 162.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M49.062,201.173c12.389,32.455,27.493,32.178,27.493,32.178l7.968-.065-3.117,3.444H62.559L53.5,221.579l4.618,15.151H53.689L44.28,213.193Z",
    transform: "translate(36.288 164.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M36.321,201.7l8.845,39.051H22.143l4.745-39.644Z",
    transform: "translate(18.147 164.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M36.321,201.552,45.166,240.6H22.143l4.769-39.313-.428,30.828,11.363.468Z",
    transform: "translate(18.147 164.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.659,48.774c2-.333,10.917-1.456,15.528-1.685C46.47,59.081,53.755,71.107,60.029,83.661c0-11.974-.708-24.382-.708-36.352.42,0,7.564.919,7.564.919A153.646,153.646,0,0,1,77.973,68.07c4.34,9.605-1.308,15.728-1.308,15.728l9.114,22.54S82.942,110,76.093,110c-3.426,0-14.294-2.953-14.294-2.953a21.667,21.667,0,0,1-15.351,4.134A52.3,52.3,0,0,1,31.921,107.4a35.788,35.788,0,0,0,1.889-8.734c1.021-13.212-9.15-49.895-9.15-49.895",
    transform: "translate(20.209 38.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(46.701 94.328)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.666,51.842A57.232,57.232,0,0,0,41.257,66.291a32.79,32.79,0,0,0,13.4,4.769c1.548,2.88,3.079,5.777,4.549,8.708,0-2.753-.044-5.53-.1-8.317a94.113,94.113,0,0,0,19.571-1.883,13.891,13.891,0,0,1-2.465,9.867c-.1,0-.2.018-.307.02a35.194,35.194,0,0,0-24.762,7.409C44.158,92.29,39.913,98.307,38.312,105.9a43.233,43.233,0,0,1-7.216-2.393,35.788,35.788,0,0,0,1.889-8.734c.741-9.613-4.44-31.638-7.318-42.932",
    transform: "translate(-25.667 -51.842)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M45.112,48.145l1.079,5.77S22.346,72.931,10.452,82.43C8.155,84.743-.948,84.415.08,80.813,4.114,66.79,45.112,48.145,45.112,48.145",
    transform: "translate(0 39.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M6.492,65.45s17.664.287,40.956,17.757l-2.435,4.871s-29.476-5.195-44.6-19.5Z",
    transform: "translate(0.34 53.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.191,48.2a51.446,51.446,0,0,0,1.359,6.82s-25.2,18.4-37.1,27.9C8.155,85.231-.948,84.9.08,81.3c4.034-14.023,46.11-38.012,46.11-33.1",
    transform: "translate(0 38.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.846,74.261a17.444,17.444,0,0,0-2.788,5.71A61.964,61.964,0,0,1,.414,69.31l8.37-4.749s4.449,1.8,14.809,5.822a33.374,33.374,0,0,0-3.746,3.877",
    transform: "translate(0.339 52.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M20.333,69.775s-6.066,3.373-7.278,9.351l-6.7-2.291a14.987,14.987,0,0,1,8.386-10.748Z",
    transform: "translate(5.204 54.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.707,47.26l.708,36.352s7.38-12.5,6.143-24.411-3.468-11.547-3.468-11.547a5.532,5.532,0,0,0-3.382-.395",
    transform: "translate(35.819 38.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.463,47.412s-1.394-.853-5.095.111A54.284,54.284,0,0,0,55.346,83.682s-17.4-33.8-19.884-36.27",
    transform: "translate(24.887 38.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M101.4,53.891S59.517,79.506,60.461,87.223s7.264,6.143,18.435-4.332,25.817-25.315,25.817-25.315Z",
    transform: "translate(49.536 44.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M70,65.873a16.51,16.51,0,0,0,1.135,12.544c.12.255.257.509.388.762-6.583,4.56-10.353,4.038-11.065-1.774-.3-2.478,3.816-6.805,9.542-11.532",
    transform: "translate(49.536 53.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M35.22,57.694l-.608-12.575a6.075,6.075,0,0,1,11.994-1.94,6,6,0,0,1,.067,1.339l.57,12.533Z",
    transform: "translate(28.301 31.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M34.9,51.067l-.287-5.95a6.075,6.075,0,1,1,11.994-1.94,6,6,0,0,1,.067,1.339L47,51.628a27.1,27.1,0,0,1-12.1-.56",
    transform: "translate(28.301 31.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M44.862,4.266a29.869,29.869,0,0,1,9.784.546A33,33,0,0,1,72.407,16.08a35.652,35.652,0,0,1,3.574,5.055l.142.244c9.065,15.752,7.46,41.321-9.449,51.358A26.572,26.572,0,0,1,54.7,76.514C37.984,77.571,22.172,62.236,19.543,45.5,16.834,28.245,25.416,6.344,44.862,4.266",
    transform: "translate(15.616 3.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M44.859,4.266a29.869,29.869,0,0,1,9.784.546A33.015,33.015,0,0,1,72.405,16.08a35.651,35.651,0,0,1,3.574,5.055l.142.244a44.594,44.594,0,0,1,3.757,33.577,19.148,19.148,0,0,0-4.885-10.488C61.963,34.153,48.9,34.6,41.877,21.646,38.369,33.407,23.651,43.087,19.548,45.5,16.831,28.245,25.416,6.344,44.859,4.266",
    transform: "translate(15.618 3.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M33.6,33.971,54.34,32.3a1.72,1.72,0,0,1,1.767,2.256c-1.82,5.406-6.054,9.358-11.232,9.776s-9.987-2.806-12.655-7.851A1.717,1.717,0,0,1,33.6,33.971",
    transform: "translate(26.245 26.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M46.576,23.2c2.183-.7,4.718,1.217,5.682,4.274s-.02,6.1-2.194,6.8S45.344,33.054,44.382,30s.018-6.108,2.194-6.8",
    transform: "translate(36.069 18.895)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(81.464 44.247)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "v"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M50.6,24.318a7.883,7.883,0,0,1,1.033,2.112c.963,3.059-.02,6.1-2.194,6.8a4.343,4.343,0,0,1-4.669-2.183q2.9-3.376,5.83-6.725",
    transform: "translate(-44.773 -24.318)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M29.66,24.29c2.2-.7,4.767,1.23,5.741,4.318s-.02,6.159-2.216,6.863-4.765-1.228-5.739-4.316S27.464,25,29.66,24.29",
    transform: "translate(22.186 19.788)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(50.467 46.03)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M33.62,25.3a7.729,7.729,0,0,1,1.234,2.365c.973,3.093-.02,6.159-2.216,6.863a4.508,4.508,0,0,1-4.9-2.52q3.01-3.294,5.884-6.709",
    transform: "translate(-27.737 -25.298)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M39.864,3.93S48.388-1.492,54.639.4c13.019,3.954,49.345,20.388,40.288,61.74-2.88,13.153-9.147,19.1-14.4,24.074,6.805-9.3,6.512-21.578,3.606-31.865-5.793-23.13-33.192-12.509-39.878-35-3.35,17.193-17.229,16.991-24.809,32-1.843,3.654-2.349,8.734-2.911,12.555a60.442,60.442,0,0,1-.864-10.248C15.532,11.572,29.076,1.872,39.864,3.93m33.2,31.394C67.83,28.743,57.319,28.142,53.09,20.271c.964,9.387,13.732,9.758,19.975,15.047Z",
    transform: "translate(12.844 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(61.218 25.149)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M47.5,24.426c-5.173-1.918-10.206-4.094-13.854-8.5,1.075-.267,2.142-.56,3.19-.881,1.215-.364,2.4-.782,3.559-1.226,3.093,3.737,9.076,5.277,13.916,7.651-2.227,1.072-4.5,2.063-6.81,2.953",
    transform: "translate(-33.646 -13.822)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(69.516 9.918)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M57.445,24.751c-1.96,1.1-3.956,2.163-5.984,3.159-4.076-2.984-9.351-4.622-13.255-7.849a35.6,35.6,0,0,0,17.6-14.609A56.826,56.826,0,0,1,68.045,16.688a35.131,35.131,0,0,1-10.6,8.062",
    transform: "translate(-38.206 -5.451)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(29.493 27.036)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M29.073,27.175a57.928,57.928,0,0,1-12.864-4q.562-4.533,1.4-8.313a52.751,52.751,0,0,0,7.811,1.663A58.85,58.85,0,0,0,40.139,16.5c-2.944,4.492-7.012,7.318-11.066,10.677",
    transform: "translate(-16.21 -14.859)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M19.113,26.12c2.882-1.292,6.7.964,8.528,5.04s.977,8.43-1.905,9.724-6.7-.964-8.53-5.04-.973-8.424,1.907-9.724",
    transform: "translate(13.311 21.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M24.237,32.974a7,7,0,0,0,2.771-1.82C31.781,40.585,40.316,49.271,50.271,51.9a29.629,29.629,0,0,0,16.35-.318,26.2,26.2,0,0,1-10.093,2.758c-12.291.779-24.087-7.314-30.517-18.3a4.051,4.051,0,0,1-.744.446c-2.842,1.274-6.59-.91-8.448-4.875a7.642,7.642,0,0,0,7.418,1.37",
    transform: "translate(13.784 25.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M37.774,81.051s-7.395,3.375-7.964,1.354,6.825-4.676,6.825-4.676Z",
    transform: "translate(24.404 63.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M37.5,84.429s-5.469,3.026-6.974,1.044,5.426-3.856,5.426-3.856Z",
    transform: "translate(24.838 66.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M36.211,87.857s-4.478.952-6.148-.269.176-4.676,3.075-3.665a4.665,4.665,0,0,1,3.073,3.934",
    transform: "translate(24.119 68.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M23.085,77.073a5.475,5.475,0,0,1,1.35-1.226A18.974,18.974,0,0,1,27.9,74.284c3.655-1.414,7.531-1.752,7.7-1.465l1.05,2.083.979,20.568c-.837-.135-2.231-.315-2.849-.5,0,0-4.9-.881-8.035-3.219a11.935,11.935,0,0,1-4.767-6.772c-.586-2.547-.577-5.77,1.1-7.908",
    transform: "translate(17.727 59.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M33.377,86s-6.554-2.031-6.923,0,7.167,4.429,8.206,3.686C35.45,89.12,33.377,86,33.377,86",
    transform: "translate(21.669 69.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M29.755,73.375s12.4,7.26,10.913,10.288-5.49-1.379-5.49-1.379,6.905,7.056,4.691,8.9S32.3,84.909,32.3,84.909s9.28,9.966,5.564,11.443-6.614-6.459-6.614-6.459,5.466,8.3,2.609,9.407-6.448-7.838-6.448-7.838Z",
    transform: "translate(22.466 60.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M88.93,69.437c.988,1.115,2.1,1.448,4.751,1.348,0,0,12.789-.677,12.975-4.088a2.667,2.667,0,0,0-1.583-2.38,2.96,2.96,0,0,0,1.658-2.365c-.044-.79-.793-1.246-1.809-1.632.966-.5,2.083-1.043,2.021-2.154-.06-1.059-1.106-1.477-2.123-1.863a2.454,2.454,0,0,0,1.268-2.442c-.211-1.112-1.861-1.4-2.762-1.541a26.721,26.721,0,0,0-5.42-.186c-1.461.062-3.674.626-5.289.468a3.526,3.526,0,0,1-2.7-2.727c-.529-1.73-.064-2.28-.457-4.052a5.546,5.546,0,0,0-2.138-3.433,3.038,3.038,0,0,0-1.745-.519c-.482.015-.8.222-.833.742a2.565,2.565,0,0,0,.142.824c1.45,5.095,2.167,9.336.681,14.511a18.313,18.313,0,0,1-.595,1.739A19.7,19.7,0,0,1,82.1,64.63s-.131,5.626,6.834,4.807",
    transform: "translate(67.279 34.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M85.852,63.71c.242-2.089,4.471-2.8,4.471-2.8a2.606,2.606,0,0,1-.771-1.217,2.325,2.325,0,0,1,1.285-2.4,2.73,2.73,0,0,1-.342-1.614c.086-1.861,1.285-1.861,1.285-1.861l-1.285-1.052c1.714-3.77,7.713-3.916,7.713-3.916s-6.014.83-6.177,3.315,2.664,1.652,2.664,1.652-3.1,1.09-2.664,3.06c0,0-2.167,1.956-.586,4.114,0,0-5.591,1.286-2.065,4.068a6.268,6.268,0,0,1-3.526-1.357",
    transform: "translate(70.358 40.039)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpWoman);
export default __webpack_public_path__ + "static/media/thumbsUpWoman.bc47a60cfcfc16298acf2ce07698c459.svg";
export { ForwardRef as ReactComponent };